import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';

const styles = () => ({
    subheading: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
});

class MAListInstall extends React.Component {
    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Collapse component="li" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/system-requirements"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="System Requirements" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/release-notes"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Release Notes" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/special-characters"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Special Characters" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/manager-installation"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Installing Managers" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/agent-installation"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Installing Agents" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/upgrade-best-practices"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Upgrade Best Practices" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/moving-manager-agents"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Moving Managers or Agents" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/securing-manager-ssl-tls"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Securing with SSL and TLS" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/installation/ipv6-support"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="IPv6 Support" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/removing-ha-installations"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Removing Clustered Installations" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/installation/disaster-recovery"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Disaster Recovery" />
                            </ListItem>
                        </NavLink>
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

MAListInstall.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    handleDrawerToggle: PropTypes.func,
    onActive: PropTypes.func,
};

export default withStyles(styles)(MAListInstall);
